var map = {
	"./notice1.mp3": 65635,
	"./notice10.mp3": 15993,
	"./notice2.mp3": 91468,
	"./notice3.mp3": 65681,
	"./notice4.mp3": 36322,
	"./notice5.mp3": 13831,
	"./notice6.mp3": 83760,
	"./notice7.mp3": 64501,
	"./notice8.mp3": 7110,
	"./notice9.mp3": 51531,
	"./notice_1.mp3": 58562
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60849;